import Bluebird from 'bluebird';
import { deferTask } from '../../../../services/defer-task';
import { isEmptyObject } from '../../../../services/utils';
import { getWidgetForm } from './models/form';
import { isDesktop } from './storage';
import { submitForm } from './submit/submit';
import { IURLData } from './url-data-reader';

export async function fillFieldsByUrlData(urlData: IURLData): Bluebird<any> {
    // Read query string
    if (isEmptyObject(urlData)) {
        return;
    }

    console.log('URL data:', urlData);

    if (urlData.from || urlData.to) {
        await urlData.flightNumber
            ? fillFlightFields(urlData)
            : fillNoFlightFields(urlData);
    }

    if (urlData.search) {
        await submitForm();
    }
}

function fillFlightFields(values: IURLData): Bluebird<void> {
    // TODO: Not implemented yet
    return fillNoFlightFields(values);
}

function fillNoFlightFields(values: IURLData): Bluebird<any> {
    if (!isDesktop) {
        // TODO: Fix noflight mobile
        return Bluebird.resolve();
    }

    const form = getWidgetForm();

    deferTask(() => {
        const check = form.noFlightCheck;
        if (!check.prop('checked')) check.click();
    });

    const promises: Array<Bluebird<void>> = [];

    const { from, to, pickupTime } = values;
    if (from) promises.push(form.row1.noflight.from.searchValue(from));
    if (to) promises.push(form.row1.noflight.to.searchValue(to));
    if (pickupTime) form.row1.noflight.datetime.val(pickupTime.format());

    return Bluebird.all(promises);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/field-filler.ts